import { Routes } from '@angular/router';
import { AuthGuard } from '@utils/guards/auth.guard';

export const variableCatalogRoutes: Routes = [
  {
    path: 'catalog-variables',
    loadComponent: () =>
      import('./catalog-variables.component').then((c) => c.CatalogVariablesComponent),
    canActivate: [AuthGuard],
  },
];
